import React from "react";

import { connect } from "react-redux";
import { useContext } from "react";
import { LayoutContext } from "./../../../../common/hoc/Layout/index";

function ApplyPendingCharges(props) {
  const { lMethods } = useContext(LayoutContext);
  return (
    <div className="acc_suspended_wrap">
      <p className="as_para">
        Your credit card was declined while processing. The reasons could be:
      </p>
      <ol className="as_ol">
        <li className="as_li">Your credit card has expired.</li>
        <li className="as_li">
          The credit card information provided was incorrect.
        </li>
        <li className="as_li">
          Your credit card does not have sufficient funds available.
        </li>
      </ol>
      <p className="as_para">
        If you wish to reactivate this account, update your credit card
        information and pay your outstanding charges.
      </p>
      <div className="plan-table">
        <div className="pln-tbl-rw">
          <div className="pln-tbl-col">
            <p className="tbl-title">
              {props.plan.id > 199 ? "Team Plan" : "Personal Plan"}
            </p>
          </div>
          <div className="pln-tbl-col">
            <span className="tbl-value">{props.plan.description}</span>
          </div>
        </div>
        <div className="pln-tbl-rw">
          <div className="pln-tbl-col">
            <p className="tbl-title">Amount</p>
          </div>
          <div className="pln-tbl-col">
            <div className="pln-tbl-col">
              <span className="tbl-value">
                <strong className="highlight">${props.plan.yearlyFee}</strong>
                <span>/year</span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <p className="as_para">
        You will be charged full price for the IDrive
        <sup>®</sup> Mirror plan.
      </p>
      <input
        onClick={() =>
          lMethods.openPopup("applyPendingChargesActivate", {
            execute: () => {
              lMethods.closePopup();
            },
            backButton: false
          })
        }
        type="button"
        value="Update Card Information"
        className="common_btn btn_primary update_card_btn"
      />
      <div className="note-sctn">
        <p className="note-title">*Note:</p>
        <ul>
          <li>
            The total includes any applicable taxes and fees. Sales tax will be
            applicable for certain regions as per the federal mandates governing
            the regions.
          </li>
        </ul>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    plan: state.account.plan
  };
}

export default connect(mapStateToProps)(ApplyPendingCharges);
